import { createElementSlot } from '@/lib/desktop-shell/element-slot';

/*
 * A library page (settings, plugins, artifacts) opens inside the shell's frame: its content fills
 * the workspace area, beside the shell's sidebar.
 */

/** The workspace area a library page covers, beside the sidebar. */
export const libraryPageSlot = createElementSlot();
